import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class DocumentManagementApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service will request an Authentication token from DMS
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    retrieveDmsAuthToken(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/oauth/dmstoken'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will retrieve an archived document from DMS for input corp code, doc class and doc id
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getArchivedDocument(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/document/{corpCode}/{docClass}/{docArchiveTimestamp}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service will archive a document in DMS System.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    archiveDocument(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/document/{corpCode}/{docClass}'), {
            pathParams: request,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will create a workflow in DMS System.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createWorkFlowRequest(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/workflow/{queueName}/{activityName}'), {
            pathParams: request,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will search for an archived document from DMS for input corp code, a tag and a value.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    searchDmsDocument(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/document/{corpCode}'), {
            pathParams: request,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will retrieve a list of active requests and total count based on input Queue Name, Activity Name and flowName.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listActiveRequestsByQueue(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/workflow/{queueName}/{activityName}/{flowName}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service retrieves imaged documents for a single Pro number from DMS.  Optionally, one or more image types can be input.  If no image type is provided then all imaged documents will be retrieved.  Supported Imaged Documents are: BL (Bill of Lading), DR (Delivery Receipt), DRRR (Delivery Return Receipt), CUST (Customs Documents), IR (Inspection Report), LOA (Letter of Authority), NCIC (NMFC Certificate), WI (Weights and Corrections), WRFO (Weights and Research photos).
     * <br/>		In addition, an image format (pdf, jpeg or tiff) can be entered. All imaged documents will be returned in this format.  If no image format is entered, all imaged documents will be returned in tiff format.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>	1. Valid input data - Pro number and image type are provided and the imaged document exists.
     * <br/>	2. Imaged document doesn't exist for input Pro number and image type.
     * <br/>Post-conditions:
     * <br/>	1.	If a Pro number and image type are provided, and the requested imaged document exists, then the image is returned. If multiple types are provided, multiple images are returned (if they exist).
     * <br/>		a.	If an image format is provided, then any requested images are returned in the requested image format.
     * <br/>	2.	If the image doesn't exist for the requested Pro number and image type, then the �Image not found� message is returned.
     * <br/>
     * <br/>Note that this operation has a multi-part response.  The data is included in the first part (listed in the response elements below) and the second part includes the binary image or images.  Please see the samples in this document for more information.
     * <br/>
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getShipmentImagedDocuments(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/shipments/{proNbr}/imaged-docs'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This service retrieves all the documents from DMS for each document ID and then merges them into one tiff file.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Valid input data - Pro number and at least 1 document information ID supplied.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. Merged Tiff file is returned that includes all the documents in the input list.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    processShipmentCustomsDocuments(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/shipments/{proNbr}/customs-documents'), {
            pathParams: request,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will retrieve an archived document from DMS for input corp code, doc class and doc id
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    addIndexToDocument(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/index/{corpCode}/{docClass}/{docArchiveTimestamp}'), {
            pathParams: request,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This service will retrieve an archived document from DMS for input corp code, doc class and doc id and convert it to the format requested by the consumer.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getDocument(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/document/{corpCode}/{docClass}/{docArchiveTimestamp}/{docFormat}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(DocumentManagementApiService.DocumentManagementApiEndpoint);
    }
}
DocumentManagementApiService.ɵfac = function DocumentManagementApiService_Factory(t) { return new (t || DocumentManagementApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
DocumentManagementApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DocumentManagementApiService, factory: DocumentManagementApiService.ɵfac });
DocumentManagementApiService.DocumentManagementApiEndpoint = 'documentmanagementApiEndpoint';
/** @nocollapse */
DocumentManagementApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DocumentManagementApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkDocumentManagementModule {
}
SdkDocumentManagementModule.ɵfac = function SdkDocumentManagementModule_Factory(t) { return new (t || SdkDocumentManagementModule)(); };
SdkDocumentManagementModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkDocumentManagementModule });
SdkDocumentManagementModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DocumentManagementApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkDocumentManagementModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    DocumentManagementApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkDocumentManagementModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * DocumentManagement API
 * Version: 1.0
 * Build: Manual
 */
class ArchiveDocumentRqst {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.docClass = undefined;
        /**
         * Document data to be archived
         * Required: true
         * Array: false
         */
        this.inputFile = undefined;
        /**
         * Metadata for the file to be archived
         * Required: true
         * Array: false
         */
        this.archiveRequest = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.dmsAuth = undefined;
    }
}
class ArchiveDocumentResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.documentInfo = undefined;
    }
}
class GetArchivedDocumentRqst {
    constructor() {
        /**
         * The Corporation Code of the  documents being located
         * Required: true
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * the document class for the document(s) being located
         * Required: true
         * Array: false
         */
        this.docClass = undefined;
        /**
         * The timestamp in microseconds in Tandem time format that the document was originally archived into DMS.
         * Required: true
         * Array: false
         */
        this.docArchiveTimestamp = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.dmsAuth = undefined;
        /**
         * Value= blackwhite
         * Required: false
         * Array: false
         */
        this.rendition = undefined;
    }
}
class GetArchivedDocumentResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.document = undefined;
    }
}
class RetrieveDmsAuthTokenRqst {
}
class RetrieveDmsAuthTokenRqst_OLD {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.grant_type = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.username = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.password = undefined;
    }
}
class RetrieveDmsAuthTokenResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.access_token = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.token_type = undefined;
        /**
         * Expiration time in seconds of the access token
         * Required: false
         * Array: false
         */
        this.expires_in = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.scope = undefined;
    }
}
/**
 * Request message to create the Workflow Request in DMS system
 */
class CreateWorkFlowRequestRqst {
    constructor() {
        /**
         * Required: true
         * Array: true
         */
        this.requestObjects = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.appWorkArea = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.activityName = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.dmsAuth = undefined;
    }
}
class CreateWorkFlowRequestResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.requestNumber = undefined;
    }
}
/**
 * Request message to search for a Document archived in DMS
 */
class SearchDmsDocumentRqst {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.searchTags = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.searchString = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.minDateTime = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.maxDateTime = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.dmsAuth = undefined;
    }
}
class SearchDmsDocumentResp {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.documentInfo = undefined;
    }
}
class ListActiveRequestsByQueueRqst {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.activityName = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.flowName = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.dmsAuth = undefined;
    }
}
class ListActiveRequestsByQueueResp {
    constructor() {
        /**
         * Total count of requests
         * Required: false
         * Array: false
         */
        this.count = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.requests = undefined;
    }
}
/**
 * Input data to retrieve 1 or more imaged documents for a single Pro number from DMS
 */
class GetShipmentImagedDocumentsRqst {
    constructor() {
        /**
         * Business Id of the Shipment
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * pdf , jpg or tiff
         * Required: false
         * Array: false
         */
        this.imageFormat = undefined;
        /**
         * type of image: BL (Bill of lading, DR(Delivery Receipt),CUST(Customs document),DRRR(Delivery Return Receipt), IR(Inspection Report), LOA(Letter of Authority),NCIC(NMFC Certificate),WI(Weight and Correction Certificate), WRFO(Weight and Research Photos)
         * Required: false
         * Array: true
         */
        this.imageType = undefined;
        /**
         * Indicates if the multiPart response should be returned. If not provided then this is assumed to be true.
         * Required: false
         * Array: false
         */
        this.multiPartResp = undefined;
        /**
         * The timestamp in microseconds in Tandem time format that the document was originally archived into DMS.
         * Required: false
         * Array: false
         */
        this.docArchiveTimestamp = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.dmsAuth = undefined;
    }
}
/**
 * Output data to retrieve a list of imaged documents from DMS
 */
class GetShipmentImagedDocumentsResp {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.imagedDocument = undefined;
    }
}
class ProcessShipmentCustomsDocumentsRqst {
    constructor() {
        /**
         * Business Id of the Shipment
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Required: true
         * Array: true
         */
        this.documents = undefined;
    }
}
class ProcessShipmentCustomsDocumentsResp {
    constructor() {
        /**
         * TIFF Binary data for customs documents
         * Required: false
         * Array: false
         */
        this.documentData = undefined;
    }
}
/**
 * Request message to Associate additional index information with a previously archived document
 */
class AddIndexToDocumentRqst {
    constructor() {
        /**
         * The Corporation Code of the  documents being located
         * Required: true
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * the document class for the document(s) being located
         * Required: true
         * Array: false
         */
        this.docClass = undefined;
        /**
         * The timestamp in microseconds in Tandem time format that the document was originally archived into DMS.
         * Required: true
         * Array: false
         */
        this.docArchiveTimestamp = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.dmsAuth = undefined;
        /**
         * Required: true
         * Array: true
         */
        this.indices = undefined;
    }
}
/**
 * Response message
 */
class AddIndexToDocumentResp {
    constructor() {
        /**
         * Response status code. Eg. 200, 400 or 404
         * Required: true
         * Array: false
         */
        this.code = undefined;
    }
}
/**
 * Input data to retrieve 1 or more imaged documents for a single Pro number from DMS
 */
class GetDocumentRqst {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * type of image: BL (Bill of lading, DR(Delivery Receipt),CUST(Customs document),DRRR(Delivery Return Receipt), IR(Inspection Report), LOA(Letter of Authority),NCIC(NMFC Certificate),WI(Weight and Correction Certificate), WRFO(Weight and Research Photos)
         * Required: true
         * Array: false
         */
        this.docClass = undefined;
        /**
         * The timestamp in microseconds in Tandem time format that the document was originally archived into DMS.
         * Required: true
         * Array: false
         */
        this.docArchiveTimestamp = undefined;
        /**
         * pdf , jpg or tiff
         * Required: true
         * Array: false
         */
        this.docFormat = undefined;
        /**
         * Indicates if the multiPart response should be returned. If not provided then this is assumed to be true.
         * Required: false
         * Array: false
         */
        this.multiPartResp = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.dmsAuth = undefined;
    }
}
/**
 * Output data to retrieve a list of imaged documents from DMS
 */
class GetDocumentResp {
    constructor() {
        /**
         * Binary data for documents.
         * Required: false
         * Array: false
         */
        this.documentData = undefined;
        /**
         * Name of the file.
         * Required: false
         * Array: false
         */
        this.fileName = undefined;
        /**
         * Mime type representing the contents of the file.
         * Required: false
         * Array: false
         */
        this.contentType = undefined;
    }
}
/**
 * Information about the documents archived in the DMS system.
 */
class DocumentInfoDetail {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.docClass = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.docNum = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.displayName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmSec = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmMin = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmHour = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmMDay = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmMon = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmYear = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmWday = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmYday = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tmlsdst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.archiveMsecs = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.vol = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.subvol = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.offset = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.mediaErr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.formatErr = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.isOffline = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.presentErr = undefined;
    }
}
/**
 * Information about the documents archived in the DMS system.
 */
class DocumentInfo {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.documentUrl = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.documentFolder = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.documentName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.createdDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.modifiedDate = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.documentAuthor = undefined;
    }
}
/**
 * Basic Information to Identify a unique document
 */
class DocumentId {
    constructor() {
        /**
         * The Corporation Code of the  documents being located
         * Required: false
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * the document class for the document(s) being located
         * Required: false
         * Array: false
         */
        this.docClass = undefined;
        /**
         * The timestamp in microseconds in Tandem time format that the document was originally archived into DMS.
         * Required: false
         * Array: false
         */
        this.docArchiveTimestamp = undefined;
    }
}
/**
 * Basic Information to Identify a unique document
 */
class DocumentCdt {
    constructor() {
        /**
         * The Corporation Code of the  documents being located
         * Required: false
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * the document class for the document(s) being located
         * Required: false
         * Array: false
         */
        this.docClass = undefined;
        /**
         * The timestamp in microseconds in Tandem time format that the document was originally archived into DMS.
         * Required: false
         * Array: false
         */
        this.timestamp = undefined;
    }
}
/**
 * Information about the index to be added
 */
class DocumentIndex {
    constructor() {
        /**
         * Optional. May be left blank. Only when an index will not be used as part a document number in a locate (searching for a document by corporation code, document class and document number) that it should have a non-blank tag value.
         * Required: false
         * Array: false
         */
        this.tag = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.value = undefined;
    }
}
class MatchedDocInfo {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.documentInfo = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.relevanceValue = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.matchingIndex = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.referenceIndex = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.additionalInfo = undefined;
    }
}
class DmsIndex {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.tag = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.value = undefined;
    }
}
class DmsArchiveRequest {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.docNumber = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.indices = undefined;
    }
}
class RequestObject {
    constructor() {
        /**
         * The Corporation Code of the  documents being located
         * Required: false
         * Array: false
         */
        this.corpCode = undefined;
        /**
         * the document class for the document(s) being located
         * Required: false
         * Array: false
         */
        this.docClass = undefined;
        /**
         * Timestamp
         * Required: false
         * Array: false
         */
        this.timestamp = undefined;
    }
}
class DocumentSearch {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.cdt = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.timestampISO = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.relevanceValue = undefined;
    }
}
class RequestId {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.requestId = undefined;
    }
}
/**
 * Information about Imaged Documents for a Pro Number
 */
class ImagedDocument {
    constructor() {
        /**
         * unique business identifier of the shipment
         * Required: false
         * Array: false
         */
        this.proNumber = undefined;
        /**
         * type of image: BL (Bill of lading, DR(Delivery Receipt),CUST(Customs document),DRRR(Delivery Return Receipt), IR(Inspection Report), LOA(Letter of Authority),NCIC(NMFC Certificate),WI(Weight and Correction Certificate), WRFO(Weight and Research Photos)
         * Required: false
         * Array: false
         */
        this.imageType = undefined;
        /**
         * image format - pdf, jpg,png, tiff
         * Required: false
         * Array: false
         */
        this.imageFormat = undefined;
        /**
         * image files
         * Required: false
         * Array: true
         */
        this.imageFiles = undefined;
        /**
         * Date when the document was scanned and imaged
         * Required: false
         * Array: false
         */
        this.scanDate = undefined;
    }
}
/**
 * Information about Imaged Documents for a Pro Number
 */
class DmsDocument {
    constructor() {
        /**
         * type of image: BL (Bill of lading, DR(Delivery Receipt),CUST(Customs document),DRRR(Delivery Return Receipt), IR(Inspection Report), LOA(Letter of Authority),NCIC(NMFC Certificate),WI(Weight and Correction Certificate), WRFO(Weight and Research Photos)
         * Required: false
         * Array: false
         */
        this.docClass = undefined;
        /**
         * image format - pdf, jpg,png, tiff
         * Required: false
         * Array: false
         */
        this.docFormat = undefined;
        /**
         * image files
         * Required: false
         * Array: false
         */
        this.imageFiles = undefined;
        /**
         * Date when the document was scanned and imaged
         * Required: false
         * Array: false
         */
        this.scanDate = undefined;
    }
}
class ImageFile {
    constructor() {
        /**
         * Name of the file.
         * Required: false
         * Array: false
         */
        this.fileName = undefined;
        /**
         * Mime type representing the contents of the file.
         * Required: false
         * Array: false
         */
        this.contentType = undefined;
        /**
         * Base 64 Formatted image data.
         * Required: false
         * Array: false
         */
        this.base64Data = undefined;
    }
}
class DmsToken {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.access_token = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.token_type = undefined;
        /**
         * Expiration time in seconds of the access token
         * Required: false
         * Array: false
         */
        this.expires_in = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.scope = undefined;
    }
}
/**
 * Query parameters for getArchivedDocument
 */
class GetArchivedDocumentQuery {
    constructor() {
        this.rendition = undefined;
    }
}
/**
 * Query parameters for getShipmentImagedDocuments
 */
class GetShipmentImagedDocumentsQuery {
    constructor() {
        this.imageFormat = undefined;
        this.imageType = undefined;
        this.multiPartResp = undefined;
        this.docArchiveTimestamp = undefined;
    }
}
/**
 * Query parameters for getDocument
 */
class GetDocumentQuery {
    constructor() {
        this.multiPartResp = undefined;
    }
}
/**
 * Path parameters for getArchivedDocument
 */
class GetArchivedDocumentPath {
    constructor() {
        this.corpCode = undefined;
        this.docClass = undefined;
        this.docArchiveTimestamp = undefined;
    }
}
/**
 * Path parameters for archiveDocument
 */
class ArchiveDocumentPath {
    constructor() {
        this.corpCode = undefined;
        this.docClass = undefined;
    }
}
/**
 * Path parameters for createWorkFlowRequest
 */
class CreateWorkFlowRequestPath {
    constructor() {
        this.queueName = undefined;
        this.activityName = undefined;
    }
}
/**
 * Path parameters for searchDmsDocument
 */
class SearchDmsDocumentPath {
    constructor() {
        this.corpCode = undefined;
    }
}
/**
 * Path parameters for listActiveRequestsByQueue
 */
class ListActiveRequestsByQueuePath {
    constructor() {
        this.queueName = undefined;
        this.activityName = undefined;
        this.flowName = undefined;
    }
}
/**
 * Path parameters for getShipmentImagedDocuments
 */
class GetShipmentImagedDocumentsPath {
    constructor() {
        this.proNbr = undefined;
    }
}
/**
 * Path parameters for processShipmentCustomsDocuments
 */
class ProcessShipmentCustomsDocumentsPath {
    constructor() {
        this.proNbr = undefined;
    }
}
/**
 * Path parameters for addIndexToDocument
 */
class AddIndexToDocumentPath {
    constructor() {
        this.corpCode = undefined;
        this.docClass = undefined;
        this.docArchiveTimestamp = undefined;
    }
}
/**
 * Path parameters for getDocument
 */
class GetDocumentPath {
    constructor() {
        this.corpCode = undefined;
        this.docClass = undefined;
        this.docArchiveTimestamp = undefined;
        this.docFormat = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkDocumentManagementModule, DocumentManagementApiService, ArchiveDocumentRqst, ArchiveDocumentResp, GetArchivedDocumentRqst, GetArchivedDocumentResp, RetrieveDmsAuthTokenRqst, RetrieveDmsAuthTokenRqst_OLD, RetrieveDmsAuthTokenResp, CreateWorkFlowRequestRqst, CreateWorkFlowRequestResp, SearchDmsDocumentRqst, SearchDmsDocumentResp, ListActiveRequestsByQueueRqst, ListActiveRequestsByQueueResp, GetShipmentImagedDocumentsRqst, GetShipmentImagedDocumentsResp, ProcessShipmentCustomsDocumentsRqst, ProcessShipmentCustomsDocumentsResp, AddIndexToDocumentRqst, AddIndexToDocumentResp, GetDocumentRqst, GetDocumentResp, DocumentInfoDetail, DocumentInfo, DocumentId, DocumentCdt, DocumentIndex, MatchedDocInfo, DmsIndex, DmsArchiveRequest, RequestObject, DocumentSearch, RequestId, ImagedDocument, DmsDocument, ImageFile, DmsToken, GetArchivedDocumentQuery, GetShipmentImagedDocumentsQuery, GetDocumentQuery, GetArchivedDocumentPath, ArchiveDocumentPath, CreateWorkFlowRequestPath, SearchDmsDocumentPath, ListActiveRequestsByQueuePath, GetShipmentImagedDocumentsPath, ProcessShipmentCustomsDocumentsPath, AddIndexToDocumentPath, GetDocumentPath };

